import { useMutation, useQueryClient } from 'react-query';

import {
  AgencyQuickReplyDto,
  CreateAgencyQuickReplyDto,
} from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

export const useCreateQuickReply = (agencyId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: CreateAgencyQuickReplyDto): Promise<AgencyQuickReplyDto> => {
      if (!agencyId) {
        return Promise.reject(new Error('Agency ID is required'));
      }

      const { data } = await client.post(`/whatsapp/quick-replies/${agencyId}`, payload);
      return data;
    },
    {
      onSuccess: () => {
        if (!agencyId) return;
        queryClient.invalidateQueries([QueryKeys.getWhatsappQuickReplies, agencyId]);
      },
    },
  );
};
